import axios from "axios";

const api = axios.create({
  baseURL: "https://tweezers-tweezers-api.sliplane.app/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("admin_token");
      window.location.href = "/twzpanel";
    }
    return Promise.reject(error);
  }
);

export default api;
